import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {css, cx} from "@panda/css";

import {mb, mt} from "@pg-design/helpers-css";
import {CloseIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import type {IRPStore} from "../../app/rp_reducer";
import {hitRailTransportRoute} from "../../offer/tracking/offer_map_events";
import {setActivePoi, setActivePoiDirections, setActivePoiRoute} from "../actions/set_poi_travel_directions";
import {useOsmPoiRoutes} from "../hooks/use_osm_poi_routes";
import {poiAnalytics, PoiGTMModalAction} from "../tracking/poi_analytics";
import {hitGtmBusRouteClick} from "../tracking/routes_gtm_events";
import type {IPublicTransportRoute} from "../types/IPublicTransportRoute";
import {IPublicTransportType} from "../types/IPublicTransportType";
import {type IPoiTravelProps, PoiTravelMode} from "./PoiTravelMode";
import {RegionTransportRoutes} from "./RegionTransportRoutes";

export interface Props extends IPoiTravelProps {
    onClose?: () => void;
}

export const PoiTravelModeInfoWindow = (props: Props) => {
    const {onClose, poi, poiType, ...forwardProps} = props;

    const dispatch = useDispatch();
    const {isMobile} = useUserDevice();

    const activePoi = useSelector((state: IRPStore) => state.maps.travelDirections.activePoi);
    const activePoiRoute = useSelector((state: IRPStore) => state.maps.travelDirections.activePoiRoute);
    const offerId = useSelector((state: IRPStore) => state.offerDetail.offer?.id);
    const propertyId = useSelector((state: IRPStore) => state.property.property?.id);
    const viewType = useSelector((state: IRPStore) => state.viewType.current);

    useEffect(() => {
        if (!props.calcTravelDataOnOpen) {
            poiAnalytics.gtm.mapEvent({action: PoiGTMModalAction.MAP_POI_CLICK, label: props.poiType});
            poiAnalytics.algolytics.poiClick(viewType, props.poiType, isMobile && activePoi ? activePoi : poi, offerId, propertyId);
        }
    }, [props.poi, props.calcTravelDataOnOpen, activePoi]);

    const {hasAnyPoiRoutes, poiRoutesGrouped} = useOsmPoiRoutes(poiType, poi.id);

    const onInfoWindowClose = () => {
        onClose?.();
        // Remove polyline - if any - from map
        dispatch(setActivePoiDirections(null));
        dispatch(setActivePoi(null, null));
    };

    const onTransportRouteClick = (poiRoute: IPublicTransportRoute) => {
        dispatch(setActivePoiRoute(poiRoute.id === activePoiRoute?.id ? null : poiRoute));
        if (poiRoute.type === IPublicTransportType.BUS) {
            hitGtmBusRouteClick();
        } else {
            hitRailTransportRoute();
        }
    };

    /*
     * On mobile we have one common place to render POI InfoWindow (instead of container per POI).
     * We want to render InfoWindow on mobile only when `activePoi` is defined.
     */
    if (isMobile && !activePoi) {
        return null;
    }

    return (
        <div className={poiTravelModeInfoWindow}>
            <span className={closePosition} onClick={onInfoWindowClose}>
                <CloseIcon size="1.6" />
            </span>

            <Text as="div" variant="headline_6">
                {poi.name}
            </Text>

            {!!poi?.tags?.address && <div className={cx(subHeading, "bt")}>{poi.tags.address}</div>}

            {hasAnyPoiRoutes && poiRoutesGrouped ? (
                <div>
                    <Text as="div" variant="info_txt_2" css={[mt(2), mb(1)]}>
                        Komunikacja
                    </Text>
                    <RegionTransportRoutes
                        busRoutes={poiRoutesGrouped?.bus}
                        railwayRoutes={poiRoutesGrouped?.train}
                        subwayRoutes={poiRoutesGrouped?.subway}
                        tramRoutes={poiRoutesGrouped?.tram}
                        activePoiRoute={activePoiRoute}
                        onTransportRouteClick={onTransportRouteClick}
                    />

                    <Text as="div" variant="info_txt_2" css={[mt(2), mb(1)]}>
                        Czas dojazdu
                    </Text>
                </div>
            ) : null}

            <div css={mt(1)}>
                <PoiTravelMode poi={poi} poiType={poiType} {...forwardProps} />
            </div>
        </div>
    );
};

const poiTravelModeInfoWindow = css({
    backgroundColor: "#fff",
    position: "relative",
    minWidth: "24rem",
    borderRadius: 2,
    padding: 2,

    md: {
        paddingRight: 1.5
    }
});

const closePosition = css({
    position: "absolute",
    top: 1,
    right: 1,
    cursor: "pointer",

    md: {
        right: 1
    }
});

const subHeading = css({
    fontSize: "0.8rem",
    lineHeight: "1.8rem"
});
import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {css, cx} from "@panda/css";

import {mb, mt} from "@pg-design/helpers-css";
import {CloseIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import type {IRPStore} from "../../app/rp_reducer";
import {hitRailTransportRoute} from "../../offer/tracking/offer_map_events";
import {setActivePoi, setActivePoiDirections, setActivePoiRoute} from "../actions/set_poi_travel_directions";
import {useOsmPoiRoutes} from "../hooks/use_osm_poi_routes";
import {poiAnalytics, PoiGTMModalAction} from "../tracking/poi_analytics";
import {hitGtmBusRouteClick} from "../tracking/routes_gtm_events";
import type {IPublicTransportRoute} from "../types/IPublicTransportRoute";
import {IPublicTransportType} from "../types/IPublicTransportType";
import {type IPoiTravelProps, PoiTravelMode} from "./PoiTravelMode";
import {RegionTransportRoutes} from "./RegionTransportRoutes";

export interface Props extends IPoiTravelProps {
    onClose?: () => void;
}

export const PoiTravelModeInfoWindow = (props: Props) => {
    const {onClose, poi, poiType, ...forwardProps} = props;

    const dispatch = useDispatch();
    const {isMobile} = useUserDevice();

    const activePoi = useSelector((state: IRPStore) => state.maps.travelDirections.activePoi);
    const activePoiRoute = useSelector((state: IRPStore) => state.maps.travelDirections.activePoiRoute);
    const offerId = useSelector((state: IRPStore) => state.offerDetail.offer?.id);
    const propertyId = useSelector((state: IRPStore) => state.property.property?.id);
    const viewType = useSelector((state: IRPStore) => state.viewType.current);

    useEffect(() => {
        if (!props.calcTravelDataOnOpen) {
            poiAnalytics.gtm.mapEvent({action: PoiGTMModalAction.MAP_POI_CLICK, label: props.poiType});
            poiAnalytics.algolytics.poiClick(viewType, props.poiType, isMobile && activePoi ? activePoi : poi, offerId, propertyId);
        }
    }, [props.poi, props.calcTravelDataOnOpen, activePoi]);

    const {hasAnyPoiRoutes, poiRoutesGrouped} = useOsmPoiRoutes(poiType, poi.id);

    const onInfoWindowClose = () => {
        onClose?.();
        // Remove polyline - if any - from map
        dispatch(setActivePoiDirections(null));
        dispatch(setActivePoi(null, null));
    };

    const onTransportRouteClick = (poiRoute: IPublicTransportRoute) => {
        dispatch(setActivePoiRoute(poiRoute.id === activePoiRoute?.id ? null : poiRoute));
        if (poiRoute.type === IPublicTransportType.BUS) {
            hitGtmBusRouteClick();
        } else {
            hitRailTransportRoute();
        }
    };

    /*
     * On mobile we have one common place to render POI InfoWindow (instead of container per POI).
     * We want to render InfoWindow on mobile only when `activePoi` is defined.
     */
    if (isMobile && !activePoi) {
        return null;
    }

    return (
        <div className={poiTravelModeInfoWindow}>
            <span className={closePosition} onClick={onInfoWindowClose}>
                <CloseIcon size="1.6" />
            </span>

            <Text as="div" variant="headline_6">
                {poi.name}
            </Text>

            {!!poi?.tags?.address && <div className={cx(subHeading, "bt")}>{poi.tags.address}</div>}

            {hasAnyPoiRoutes && poiRoutesGrouped ? (
                <div>
                    <Text as="div" variant="info_txt_2" css={[mt(2), mb(1)]}>
                        Komunikacja
                    </Text>
                    <RegionTransportRoutes
                        busRoutes={poiRoutesGrouped?.bus}
                        railwayRoutes={poiRoutesGrouped?.train}
                        subwayRoutes={poiRoutesGrouped?.subway}
                        tramRoutes={poiRoutesGrouped?.tram}
                        activePoiRoute={activePoiRoute}
                        onTransportRouteClick={onTransportRouteClick}
                    />

                    <Text as="div" variant="info_txt_2" css={[mt(2), mb(1)]}>
                        Czas dojazdu
                    </Text>
                </div>
            ) : null}

            <div css={mt(1)}>
                <PoiTravelMode poi={poi} poiType={poiType} {...forwardProps} />
            </div>
        </div>
    );
};

const poiTravelModeInfoWindow = css({
    backgroundColor: "#fff",
    position: "relative",
    minWidth: "24rem",
    borderRadius: 2,
    padding: 2,

    md: {
        paddingRight: 1.5
    }
});

const closePosition = css({
    position: "absolute",
    top: 1,
    right: 1,
    cursor: "pointer",

    md: {
        right: 1
    }
});

const subHeading = css({
    fontSize: "0.8rem",
    lineHeight: "1.8rem"
});
